import { useState } from "react";
import * as XLSX from "xlsx";
import useAsset from "./useAsset";



const usePromptLibraryData = () => {

    const [promptLibraryData, setPromptLibraryData] = useState<any[]>([]);
    const { fetchAsset } = useAsset();

    const readExcelFromBlob = async (blobURL: string) => {
    try {
      const response = await fetch(blobURL); // Fetch the Blob from the local URL
      const blob = await response.blob();
      const arrayBuffer = await blob.arrayBuffer(); // Convert to ArrayBuffer

      const workbook = XLSX.read(arrayBuffer, { type: "array" });
      const sheetName = workbook.SheetNames[0]; // Get first sheet
      const sheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(sheet); // Convert to JSON
      setPromptLibraryData(jsonData);
      console.log("Excel Data:", jsonData);
    } catch (error) {
      console.error("Error reading Excel Blob:", error);
    }
  }

  const getPromptLibraryExcel = async () => {

    const promptLibraryExcel = {
      containerName: "lib-market",
      folder: "",
      sourceName: "Prompts_Library",
      extension: "xlsx",
      mediaType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      //path: "https://stgeorgesproddoc.blob.core.windows.net/lib-market/Prompts_Library.xlsx",
      //full_path: "https://stgeorgesproddoc.blob.core.windows.net/lib-market/Prompts_Library.xlsx",
      fullPath: "lib-market/Prompts_Library.xlsx"
    }

    const asset = await fetchAsset(promptLibraryExcel);

    readExcelFromBlob(asset);
    
    return asset;
  }

  return {
    promptLibraryData,
    getPromptLibraryExcel
  }

}

export default usePromptLibraryData;
